import { get } from "../helper/request";

export const getBonusCreditMe = async () => {
  return get(`${process.env.REACT_APP_API_URL_V2}bonus-credit/me`);
};
export const getBonusCampaignAPI = async () => {
  return get(`${process.env.REACT_APP_API_URL_V2}user/account/deposit-coupon`);
};
